import { memo } from "react";
import { FieldTypeEditorProps } from "../types";

export const UrlFieldTypeSpecificProps = memo(
  (_props: FieldTypeEditorProps) => null,
);
